import InputUrl from './InputUrl';

export default InputUrl;
